import gql from 'graphql-tag'
import { ICalendar } from '@api/types'

import client from '@stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        calendars: ICalendar[]
      }
    }
  }
}

export default function fetchCalendars(): Promise<ICalendar[]> {
  return client.gql.query({ query: calendarsQuery }).then(
    ({
      data: {
        viewer: {
          company: { calendars },
        },
      },
    }: Payload) => calendars
  )
}

export const calendarsQuery = gql`
  query calendars {
    viewer {
      company {
        calendars {
          id
          calendarName
        }
      }
    }
  }
`
